import React from "react"
import DatePicker from "react-datepicker"

import "./styles.less"

export default ({
  value = new Date(),
  setValue = () => null,
  minDate = null,
  className = "",
  ...props
}) => {
  return (
    <div className="weekend-disabled">
      <DatePicker
        {...props}
        className={className}
        selected={value}
        onChange={(val) => setValue(val)}
        showPopperArrow={false}
        minDate={minDate || new Date()}
      />
    </div>
  )
}
